export var URL_QUERY_PARAM_BRIDGE_KEY = 'xpb';
export var URL_QUERY_PARAM_ID_KEY = 'xpid';
export var URL_QUERY_PARAM_SOURCE_KEY = 'xps';
export var generateUrlWithParams = function generateUrlWithParams(url, bridge, interactionSessionId, interactionSource, subProduct) {
  var completeInteractionSource;
  var urlObj = new URL(url);
  urlObj.searchParams.set(URL_QUERY_PARAM_BRIDGE_KEY, bridge);
  urlObj.searchParams.set(URL_QUERY_PARAM_ID_KEY, interactionSessionId);
  completeInteractionSource = subProduct ? "".concat(interactionSource, ".").concat(subProduct) : interactionSource;
  urlObj.searchParams.set(URL_QUERY_PARAM_SOURCE_KEY, completeInteractionSource);
  return urlObj.toString();
};